export enum Bundle {
    Flow = 'flow',
    Product = 'product',
    Story = 'story',
}
